export const FONT_BASE = {
  COPY: 'avenirnextroundedpro-demi',
  TITLE: 'lubalingraphitcturner-bold',
  CSS: ['fonts.css'],
};

export const FONTS = {
  BOOT: [FONT_BASE],
  APP: [],
};
